import { absolutePath } from "./absolutePath";

export const planTrials = {
  destroy: () => absolutePath("plan_trials"),
};
